module.exports = __webpack_public_path__ + "img/gereg1.ba933428.jpg";